/** Доступ к модулю решает backend (PlatformModule). Фронт не режет по subdomain. */

export const ANALYTICS_PRO_PRICE_RUB = 600;

export function isAnalyticsProAllowed(_tenantOrSubdomain) {
  return true;
}

export function formatPriceRub(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return "—";
  return `${n.toLocaleString("ru-RU")} ₽`;
}

export function isAnalyticsProActive(moduleOrTenant, plan) {
  if (plan?.analyticsPro) return true;
  if (!moduleOrTenant) return false;
  if (moduleOrTenant.active != null) return Boolean(moduleOrTenant.active);
  const until = moduleOrTenant.paid_until || moduleOrTenant.analytics_pro_paid_until;
  if (!until) return false;
  return String(until).slice(0, 10) >= new Date().toISOString().slice(0, 10);
}
